(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8576],{

/***/ 26518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ ContentfulContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/** @public */
var ContentfulContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
/** @public */
var ContentfulProvider = function (_a) {
    var contentful = _a.contentful, children = _a.children;
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ContentfulContext.Provider, { value: contentful }, children);
};
ContentfulProvider.displayName = 'ContentfulProvider';
ContentfulContext.displayName = 'ContentfulContext';
/* harmony default export */ __webpack_exports__["Z"] = (ContentfulProvider);
//# sourceMappingURL=ContentfulProvider.js.map

/***/ }),

/***/ 21643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "So": function() { return /* binding */ FeatureContext; }
/* harmony export */ });
/* unused harmony export FeatureConsumer */
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
var _excluded=["features"];var FeatureContext=/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext();var FeatureConsumer=FeatureContext.Consumer;var FeatureProvider=function FeatureProvider(_ref){var features=_ref.features,props=(0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref,_excluded);return/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(FeatureContext.Provider,(0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({value:features},props));};FeatureProvider.defaultProps={features:[]};FeatureProvider.propTypes={features:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().object)};/* harmony default export */ __webpack_exports__["ZP"] = (FeatureProvider);
//# sourceMappingURL=FeatureProvider.js.map

/***/ }),

/***/ 65846:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flights",
      function () {
        return __webpack_require__(6166);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _constants_products__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85968);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var _obj;
var BANNER_TEXT_VALUES = (_obj = {}, _defineProperty(_obj, _constants_products__WEBPACK_IMPORTED_MODULE_0__/* .FLIGHT_PRODUCT_TYPE */ .oP, {
    titleText: 'Get the app. Save more.',
    contentText: 'Save up to 40% on flights with the app',
    pageId: 'MWEB_FLT_HP_HEADER'
}), _defineProperty(_obj, _constants_products__WEBPACK_IMPORTED_MODULE_0__/* .HOME_PRODUCT_TYPE */ .Wn, {
    titleText: 'Get the app. Save more.',
    contentText: 'Get exclusive deals only in our app',
    pageId: 'MWEB_HTL_HP_HEADER'
}), _defineProperty(_obj, _constants_products__WEBPACK_IMPORTED_MODULE_0__/* .HOTEL_PRODUCT_TYPE */ .kd, {
    titleText: 'Get the app. Save more.',
    contentText: 'Save up to 60% off hotels with the app',
    pageId: 'MWEB_HTL_HP_HEADER'
}), _obj);
/* harmony default export */ __webpack_exports__["Z"] = (BANNER_TEXT_VALUES);


/***/ }),

/***/ 13326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rg": function() { return /* binding */ getLink; },
/* harmony export */   "Cx": function() { return /* binding */ shouldHideAppBanner; },
/* harmony export */   "we": function() { return /* binding */ getPropsForAppBanner; }
/* harmony export */ });
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69376);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57330);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58493);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72593);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24088);
/* harmony import */ var _shared_utils_isLoadedInAppView__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27781);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var buildReferralData = function(isAndroid, referral) {
    return (0,ramda__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        sourceId: '',
        id: 'DTAPPDL',
        clickId: isAndroid ? 'MWEBHPANDROID' : 'MWEBHPIOS'
    }, referral);
};
var baseUrlAndroid = 'https://www.priceline.com/r/app/';
var baseUrlNoAndroid = 'https://offers.priceline.com/lrapp/';
var getLink = function(isAndroid, referral, clientGUID, pageId) {
    var ref = buildReferralData(isAndroid, referral), id = ref.id, sourceId = ref.sourceId, _clickId = ref.clickId, clickId = _clickId === void 0 ? '' : _clickId;
    var queryStringObject = _objectSpread({
        channel: 'Display',
        product: 'App',
        theme: 'app_dl_install',
        refid: "".concat(sourceId).concat(id),
        refclickid: clickId,
        PAGEID: pageId
    }, clientGUID && {
        subSiteId: clientGUID
    });
    var baseUrl = isAndroid ? baseUrlAndroid : baseUrlNoAndroid;
    return (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(baseUrl, '?'), (0,ramda__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)('&', (0,ramda__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,ramda__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)('='), (0,ramda__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(queryStringObject))));
};
var getTrafficInfo = function(query, referral) {
    var tmp = referral.id, _ckReferralId = tmp === void 0 ? '' : tmp, tmp1 = referral.clickId, cookieRefClickId = tmp1 === void 0 ? '' : tmp1, tmp2 = referral.sourceId, _ckRefSourceId = tmp2 === void 0 ? '' : tmp2;
    var cookieRefId = _ckRefSourceId.concat(_ckReferralId);
    var tmp3 = query.refid, _qsRefId = tmp3 === void 0 ? '' : tmp3, tmp4 = query.refclickid, _qsRefClickId = tmp4 === void 0 ? '' : tmp4;
    var queryRefId = typeof _qsRefId === 'string' && Object.keys(_qsRefId).length > 0 ? _qsRefId : '';
    var queryRefClickId = typeof _qsRefClickId === 'string' && Object.keys(_qsRefClickId).length > 0 ? _qsRefClickId : '';
    var isPaid = cookieRefId.indexOf('GOOGLECPC|MSN') > -1 || queryRefId.indexOf('GOOGLECPC|MSN') > -1;
    var isBranded = cookieRefClickId.indexOf('BRAND') > -1 || queryRefClickId.indexOf('BRAND') > -1;
    var excludedRefIds = [
        'PLHTLCOMBINED',
        'PLHBC10161OPQ'
    ];
    var isBlackListed = cookieRefId.indexOf('CO') === 0 || queryRefId.indexOf('CO') === 0 || excludedRefIds.indexOf(cookieRefId) > -1 || excludedRefIds.indexOf(queryRefId) > -1;
    return {
        isPaid: isPaid,
        isBranded: isBranded,
        isBlackListed: isBlackListed
    };
};
var shouldHideAppBanner = function(data, query) {
    var isCookieSetToHideAppBanner = data.isCookieSetToHideAppBanner, isMobile = data.isMobile, referral = data.referral;
    var ref = getTrafficInfo(query, referral), isPaid = ref.isPaid, isBranded = ref.isBranded, isBlackListed = ref.isBlackListed;
    return isCookieSetToHideAppBanner || (0,_shared_utils_isLoadedInAppView__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(query) || !isMobile || isPaid && !isBranded || isBlackListed;
};
var getPropsForAppBanner = function(data) {
    var referral = data.referral, webstats = data.webstats, isMobile = data.isMobile, isAndroid = data.isAndroid;
    var ref;
    return {
        referral: referral !== null && referral !== void 0 ? referral : {},
        clientGUID: (ref = webstats === null || webstats === void 0 ? void 0 : webstats.clientGUID) !== null && ref !== void 0 ? ref : '',
        isMobile: isMobile,
        isAndroid: isAndroid
    };
};


/***/ }),

/***/ 85968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZE": function() { return /* binding */ CRUISE_PRODUCT_TYPE; },
/* harmony export */   "oP": function() { return /* binding */ FLIGHT_PRODUCT_TYPE; },
/* harmony export */   "Wn": function() { return /* binding */ HOME_PRODUCT_TYPE; },
/* harmony export */   "kd": function() { return /* binding */ HOTEL_PRODUCT_TYPE; },
/* harmony export */   "Jz": function() { return /* binding */ RENTAL_CAR_PRODUCT_TYPE; },
/* harmony export */   "nu": function() { return /* binding */ VACATION_PACKAGE_PRODUCT_TYPE; }
/* harmony export */ });
/* unused harmony export TRIPS_PRODUCT_TYPE */
var CRUISE_PRODUCT_TYPE = 'cruises';
var FLIGHT_PRODUCT_TYPE = 'flights';
var HOME_PRODUCT_TYPE = 'home';
var HOTEL_PRODUCT_TYPE = 'hotels';
var RENTAL_CAR_PRODUCT_TYPE = 'cars';
var TRIPS_PRODUCT_TYPE = 'trips';
var VACATION_PACKAGE_PRODUCT_TYPE = 'vacations';


/***/ }),

/***/ 6166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var _pcln_contentful_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26518);
/* harmony import */ var _pcln_whitelabel_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42796);
/* harmony import */ var _pcln_feature_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21643);
/* harmony import */ var _constants_products__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85968);
/* harmony import */ var _components_AppBanner_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13326);
/* harmony import */ var _components_AppBanner_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65720);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}










var AppBanner = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_2__["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6592), __webpack_require__.e(9397)]).then(__webpack_require__.bind(__webpack_require__, 29397));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29397)
            ];
        }
    }
});
var appBannerValues = _components_AppBanner_constants__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[_constants_products__WEBPACK_IMPORTED_MODULE_5__/* .FLIGHT_PRODUCT_TYPE */ .oP];
var Layout = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_2__["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9126), __webpack_require__.e(6592), __webpack_require__.e(766), __webpack_require__.e(7771), __webpack_require__.e(2947), __webpack_require__.e(7138)]).then(__webpack_require__.bind(__webpack_require__, 32947));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32947)
            ];
        }
    }
});
var Flight = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_2__["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5741), __webpack_require__.e(5058)]).then(__webpack_require__.bind(__webpack_require__, 35058));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35058)
            ];
        }
    }
});
var PartnerLayout = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_2__["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9126), __webpack_require__.e(6592), __webpack_require__.e(766), __webpack_require__.e(7771), __webpack_require__.e(2052)]).then(__webpack_require__.bind(__webpack_require__, 79136));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79136)
            ];
        }
    }
});
var PartnerFlight = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_2__["default"])(function() {
    return __webpack_require__.e(/* import() */ 7622).then(__webpack_require__.bind(__webpack_require__, 47622));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47622)
            ];
        }
    }
});
var Flights = function(param) {
    var headerHTML = param.headerHTML, footerHTML = param.footerHTML, bootstrapData = param.bootstrapData;
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().query;
    var env = bootstrapData.env, featureToggles = bootstrapData.featureToggles, _partner = bootstrapData.partner, partner = _partner === void 0 ? null : _partner;
    var shouldShowAppBanner = !(0,_components_AppBanner_utils__WEBPACK_IMPORTED_MODULE_6__/* .shouldHideAppBanner */ .Cx)(bootstrapData, query);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pcln_feature_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        features: featureToggles,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pcln_contentful_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            contentful: bootstrapData.contentful,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pcln_whitelabel_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                appName: "m-fly-search",
                partner: partner,
                env: env,
                children: (partner === null || partner === void 0 ? void 0 : partner.isWLPartner) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PartnerLayout, {
                    partner: partner,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PartnerFlight, {})
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        shouldShowAppBanner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AppBanner, _objectSpread({}, (0,_components_AppBanner_utils__WEBPACK_IMPORTED_MODULE_6__/* .getPropsForAppBanner */ .we)(bootstrapData), appBannerValues)),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Layout, {
                            headerHTML: headerHTML,
                            footerHTML: footerHTML,
                            partner: partner,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Flight, {})
                        })
                    ]
                })
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Flights);


/***/ }),

/***/ 27781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isLoadedInAppView; }
/* harmony export */ });
function isLoadedInAppView(query) {
    var NEGOTIATORAPP = query.NEGOTIATORAPP, negotiatorapp = query.negotiatorapp;
    return NEGOTIATORAPP !== undefined || negotiatorapp !== undefined;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4001,7615,2130,9774,2888,179], function() { return __webpack_exec__(65846); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);